export default {
  TARGET: process.env.TARGET,
  COMMON_URL: process.env.COMMON_URL,
  NOTIFY_URL: process.env.NOTIFY_URL,
  BOARD_URL: process.env.BOARD_URL,
  TALK_URL: process.env.TALK_URL,
  MAIL_URL: process.env.MAIL_URL,
  CALENDAR_URL: process.env.CALENDAR_URL,
  CONTACT_URL: process.env.CONTACT_URL,
  DRIVE_URL: process.env.DRIVE_URL,
  TASK_URL: process.env.TASK_URL,
  FORM_URL: process.env.FORM_URL,
  AUTH_URL: process.env.AUTH_URL,
  TEMPLATE_URL: process.env.TEMPLATE_URL,
  ADMIN_URL: process.env.ADMIN_URL,
  LCS_SERVER_NAME: process.env.LCS_SERVER_NAME,
  CAMPAIGNCODE_URL: process.env.CAMPAIGNCODE_URL,
  DRIVE_API_URL: process.env.DRIVE_API_URL,
  MAIL_DOWNLOAD_URL: process.env.MAIL_DOWNLOAD_URL,
  WORKPLACE_URL : process.env.WORKPLACE_URL,
};
